import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { toJS } from 'mobx'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import { startCase, toLower } from 'lodash'
import Row from '@components/Details/Row'
import DetailsLanguages from '@components/Languages/DetailsLanguages'

class PersonalInfo extends Component {
  static propTypes = {
    expert: PropTypes.object,
    expertStore: PropTypes.object,
    staticData: PropTypes.object
  }

  renderPhones = () => {
    const { expert } = this.props
    if (!expert.address?.phones && !expert.expert?.phoneTypeId) {
      return null
    }
    let phones = expert.address.phones

    if (expert.expert.phoneTypeId) {
      phones = [
        ...phones,
        {
          phoneTypeId: expert.expert.phoneTypeId,
          phoneNum: expert.expert.phoneNum,
          isAddedByExpert: true
        }
      ]
    }

    return phones.map(phone => {
      const phoneType = this.props.expertStore.staticData.phoneTypes.find(
        item => {
          return phone.phoneTypeId === item.id
        }
      )

      let label = get(phoneType, 'name', 'not specified')
      if (phone.isAddedByExpert) {
        label = `${label} (added by expert)`
      }

      return <Row key={phone.id} label={label} text={phone.phoneNum} />
    })
  }

  renderSubIndustries = () => {
    const { expertStore, staticData } = this.props
    const subIndustries = toJS(expertStore.expert.expert?.subIndustries)

    if (
      !expertStore.expert.expert?.subIndustries &&
      !expertStore.expert.expert?.industry
    ) {
      return (
        <Row key={'undefined'} label={'Industry / Subindustry'} text={`-`} />
      )
    }

    return subIndustries.map((subIndustry, index) => {
      const industry =
        staticData.names.industries[subIndustry.industryId] ||
        expertStore.expert.expert.industry
      let label = ''
      if (index === 0) {
        label = 'Industry / Subindustry'
      }
      return (
        <Row
          key={subIndustry.id}
          label={label}
          text={`${industry} / ${subIndustry.name}`}
        />
      )
    })
  }

  render() {
    const { expert, expertStore } = this.props

    let country = "-"

    if (expert.address?.country?.name) {
      country = expert.address.country.name
    } else if (expert.address?.countryId) {
      const matchedCountry = this.props.staticData.countries.find(e => e.id == expert.address.countryId)
      if (matchedCountry) {
        country = matchedCountry.name
      }
    }


    return (
      <div className="story">
        <span className="label">Personal information</span>
        <div className="group-wrapper">
          <div className="group">
            <Row label="City" text={get(expert.address, 'city', '-')} />
            <Row label="State" text={get(expert.address, 'state', '-')} />
            <Row
              label="Country"
              text={country}
            />
            <Row label="Timezone" text={expertStore.timezone} />
          </div>

          <div className="group">{this.renderPhones()}</div>

          <div className="group">
            <Row label="Email" text={expert.email} mailTo copiable />
            {expert.address?.emails && expert.address.emails.map(email => (
              <Row key={email.id} text={email.email} mailTo copiable />
            ))}
            {expert.links && expert.links.map((link, index) => {
              let label = ''
              if (index === 0) {
                label = 'Professional profile'
              }
              return (
                <Row
                  key={link.id}
                  label={label}
                  externalLink={link.professionalLinkUrl}
                />
              )
            })}
          </div>

          <div className="group">{this.renderSubIndustries()}</div>

          <div className="group">
            <DetailsLanguages languages={expert.languages} />
          </div>
          <div className="group">           
            <Row label="Hourly rate" text={expertStore.hourlyRate} />
            <Row label="Current US Government employee" text={expert.expert?.currentUsGovernmentEmployee ? 'Yes' : 'No'} />
          </div>
          <div className="group">
            <Row label="Recruited by" tooltip="With who the compliance was signed"
            tooltipPlacement="top"
            text={startCase(toLower(expert?.expert?.complianceReferrerName))} />
          </div>
        </div>
      </div>
    )
  }
}

export default inject('expertStore', 'staticData')(observer(PersonalInfo))
